var map = {
	"./camp.svg": "4dac",
	"./club.svg": "24e0",
	"./competition.svg": "8d98",
	"./default_marker.svg": "b7c5",
	"./facility.svg": "c0fd",
	"./fun.svg": "1bd6",
	"./meetup.svg": "085f",
	"./olympian.svg": "da0c",
	"./training.svg": "50cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b1f";